import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, beforeAlt = "Voor", afterAlt = "Na" }) => {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const [dragging, setDragging] = useState(false);

  const updateFromClientX = useCallback((clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(97, Math.max(3, pct)));
  }, []);

  const onPointerDown = (e) => {
    setDragging(true);
    e.currentTarget.setPointerCapture?.(e.pointerId);
    updateFromClientX(e.clientX);
  };
  const onPointerMove = (e) => {
    if (dragging) updateFromClientX(e.clientX);
  };
  const stopDrag = () => setDragging(false);

  const onKeyDown = (e) => {
    if (e.key === "ArrowLeft") setPos((p) => Math.max(3, p - 4));
    if (e.key === "ArrowRight") setPos((p) => Math.min(97, p + 4));
  };

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative aspect-[16/10] rounded-2xl overflow-hidden border border-slate-200 shadow-sm select-none touch-none cursor-ew-resize"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={stopDrag}
      onPointerLeave={stopDrag}
    >
      {/* Na-foto (volledige breedte, onderlaag) */}
      <img src={after} alt={afterAlt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" draggable="false" />
      {/* Voor-foto (bovenlaag, geclipt op sliderpositie) */}
      <div className="absolute inset-0 overflow-hidden" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={beforeAlt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" draggable="false" />
      </div>

      {/* Scheidingslijn + handgreep */}
      <div className="absolute inset-y-0 w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,0.4)]" style={{ left: `${pos}%` }}>
        <button
          type="button"
          data-testid="before-after-handle"
          aria-label="Vergelijk voor en na — sleep of gebruik pijltjestoetsen"
          onKeyDown={onKeyDown}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow-lg ring-1 ring-black/10 flex items-center justify-center text-maas focus:outline-none focus-visible:ring-2 focus-visible:ring-maas cursor-ew-resize"
        >
          <MoveHorizontal className="h-5 w-5" />
        </button>
      </div>

      {/* Labels */}
      <span className="absolute top-3 left-3 rounded-full bg-black/60 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white pointer-events-none">Voor</span>
      <span className="absolute top-3 right-3 rounded-full bg-maas/90 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-white pointer-events-none">Na</span>
    </div>
  );
};
